export type Leader = {
  name: string;
  role: string;
  image: string;
};

export const EXECUTIVE_BOARD: Leader[] = [
  { name: 'Minseo Kim', role: 'President', image: 'Minseo_Kim.jpg' },
  { name: 'Quincy Leung', role: 'Vice President', image: 'Quincy_Leung.jpg' },
  { name: 'Caden Tebow', role: 'Director of Engagement', image: 'Caden_Tebow.jpg' },
  { name: 'Veronica Sokoloff', role: 'Director of Finance', image: 'Veronica_Sokoloff.jpg' },
  { name: 'Elena Loucks', role: 'Director of Marketing', image: 'Elena_Loucks.jpg' },
  { name: 'Adrian Dai', role: 'Co-Director of Membership', image: 'Adrian_Dai.jpg' },
  { name: 'Elizabeth Zhao', role: 'Co-Director of Membership', image: 'Elizabeth_Zhao.jpg' },
  { name: 'Isabella Ahuactzin', role: 'Director of Outreach', image: 'Isabella_Ahuactzin.jpg' },
  { name: 'Aeliya Grover', role: 'Co-Director of Professional Development', image: 'Aeliya_Grover.jpg' },
  { name: 'Eugenia Osei Bonsu', role: 'Co-Director of Professional Development', image: 'Eugenia_OseiBonsu.jpg' },
  { name: 'Paulina DePaulo', role: 'Director of Technology', image: 'Paulina_DePaulo.jpg' },
];
